var React = require('react');

function ChevronRightGallery (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.7821 11.2179L9.5562 4.99198L8 6.54818L13.4478 11.996L8 17.4438L9.5562 19L15.7821 12.7741C15.9884 12.5677 16.1043 12.2878 16.1043 11.996C16.1043 11.7042 15.9884 11.4243 15.7821 11.2179Z","fill":"white"}));
}

ChevronRightGallery.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronRightGallery;

ChevronRightGallery.default = ChevronRightGallery;
